module.exports = __webpack_public_path__ + "sounds/cf0af62cead42e144fc4226162c8a8d1.mp3";


//////////////////
// WEBPACK FOOTER
// ./common/assets/sounds/hit.mp3
// module id = 96
// module chunks = 0